var $e01b4013a471f6b5$exports = {};
$e01b4013a471f6b5$exports = {
  "collapse": "Zbali\u0165",
  "expand": "Rozbali\u0165"
};
export { $e01b4013a471f6b5$exports as default };